// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2XNB6","inner":"Footer_inner__2J-EO","nextIcon":"Footer_nextIcon__20fH-","innerLeft":"Footer_innerLeft__26U2g"};